export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-480w.7d3fb45f.webp";